var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("label", { attrs: { for: "filters-id" } }, [
      _vm._v(_vm._s(_vm.filters.label))
    ]),
    _vm._v(" "),
    _c(
      "select",
      {
        attrs: { id: "filters-id", eventName: _vm.eventName },
        on: { change: _vm.updateValue }
      },
      _vm._l(_vm.filters.options, function(option) {
        return _c(
          "option",
          { key: option.id, domProps: { value: option.value } },
          [_vm._v(_vm._s(option.label))]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fcba86a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fcba86a6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/geneco/resources/form/elements/DropDown.vue
// module id = 566
// module chunks = 0